import api from './index';

export const apiPutCompanyResponsibilities = async (companyId, taskId, bucket) => {
  try {
    const { data } = await api.put(`/companies/${companyId}/task/${taskId}/responsibility`, {
      ...bucket,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetCompanyResponsibilities = async (companyId) => {
  try {
    const { data } = await api.get(`/companies/${companyId}/responsibility-roles?show_select=true`);
    return data;
  } catch (error) {
    throw error;
  }
};
